import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const publicApi = axios.create({ baseURL: API });

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, [getToken]);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const pkr = (n) => `PKR ${Number(n || 0).toLocaleString("en-PK")}`;

export const fmtDate = (d, opts = { day: "numeric", month: "short" }) =>
  d ? new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", opts) : "";

export const dateRange = (a, b) =>
  a === b ? fmtDate(a, { day: "numeric", month: "short", year: "numeric" }) : `${fmtDate(a)} – ${fmtDate(b, { day: "numeric", month: "short", year: "numeric" })}`;

export const VIBE_NAMES = {
  "quiet-corners": "Quiet Corners",
  "creative-resets": "Creative Resets",
  movement: "Movement",
  "nature-escapes": "Nature Escapes",
};

export const VIBE_IMAGES = {
  "quiet-corners": "https://images.unsplash.com/photo-1551927411-95e412943b58?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "creative-resets": "https://images.unsplash.com/photo-1590605095243-072811dbe64c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  movement: "https://images.unsplash.com/photo-1758797315487-b3b225dff7d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "nature-escapes": "https://images.unsplash.com/photo-1569173112611-52a7cd38bea9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const DURATION_NAMES = { weekend: "Weekend", "full-day": "Full day", "multi-day": "Multi-day" };
